module.exports = __webpack_public_path__ + "img/LenovoDCGChina.c0ccd7f6.jpg";